(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const filtersRootSelector = '#CollectionFilters';
    const gridSelector = '#ProductGridContainer';

    function bindAjaxFilters(root = document) {
      const form = root.querySelector(`${filtersRootSelector} .filter-form`);
      if (!form) return;

      const onChange = async () => {
        const gridEl = document.querySelector(gridSelector);
        const filtersEl = document.querySelector(filtersRootSelector);
        if (!gridEl || !filtersEl) return;

        const formData = new FormData(form);
        const params = new URLSearchParams(formData);

        // URL aktualisieren ohne Reload
        const nextUrl = `${window.location.pathname}?${params.toString()}`;
        history.replaceState({}, '', nextUrl);

        // Loading State (optional)
        gridEl.setAttribute('aria-busy', 'true');

        try {
          const res = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) return;

          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Grid ersetzen
          const newGrid = doc.querySelector(gridSelector);
          if (newGrid) gridEl.replaceWith(newGrid);

          // Filter ersetzen (damit Counts/Active-Filters stimmen)
          const newFilters = doc.querySelector(filtersRootSelector);
          if (newFilters) filtersEl.replaceWith(newFilters);

          // Events neu binden, weil DOM ersetzt wurde
          bindAjaxFilters(document);
        } finally {
          const newGridEl = document.querySelector(gridSelector);
          if (newGridEl) newGridEl.removeAttribute('aria-busy');
        }
      };

      // Nur Inputs/Selects im Filter-Form
      form.querySelectorAll('input, select').forEach((el) => {
        el.addEventListener('change', (e) => {
          // Optional: Verhindert, dass ein Submit-Button irgendwas ausloest
          if (e.target && e.target.type === 'submit') return;
          onChange();
        });
      });

      // Optional: Active-Filters Links (url_to_remove) abfangen, damit auch die per AJAX laufen
      root.querySelectorAll(`${filtersRootSelector} a`).forEach((a) => {
        a.addEventListener('click', async (e) => {
          const href = a.getAttribute('href');
          if (!href) return;
          // Nur interne Links abfangen
          if (!href.startsWith('/') && !href.startsWith(window.location.origin)) return;

          e.preventDefault();
          history.replaceState({}, '', href);

          const gridEl = document.querySelector(gridSelector);
          const filtersEl = document.querySelector(filtersRootSelector);
          if (!gridEl || !filtersEl) return;

          gridEl.setAttribute('aria-busy', 'true');
          try {
            const res = await fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!res.ok) return;

            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const newGrid = doc.querySelector(gridSelector);
            if (newGrid) gridEl.replaceWith(newGrid);

            const newFilters = doc.querySelector(filtersRootSelector);
            if (newFilters) filtersEl.replaceWith(newFilters);

            bindAjaxFilters(document);
          } finally {
            const newGridEl = document.querySelector(gridSelector);
            if (newGridEl) newGridEl.removeAttribute('aria-busy');
          }
        });
      });
    }

    bindAjaxFilters(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-option-buttons"] && !Shopify.designMode) return;
  try {
    const variantOptionsRoots = document.querySelectorAll('[data-variant-options]');

  variantOptionsRoots.forEach((variantOptionsRoot) => {
    const variantsJsonEl = variantOptionsRoot.querySelector('[data-product-variants-json]');
    const productFieldsJsonEl = variantOptionsRoot.querySelector('[data-product-custom-fields-json]');
    const productFields = productFieldsJsonEl ? JSON.parse(productFieldsJsonEl.textContent || '[]') : [];
    const customLineItemsI18nEl = variantOptionsRoot.querySelector('[data-custom-line-items-i18n]');
    const customLineItemsI18n = customLineItemsI18nEl ? JSON.parse(customLineItemsI18nEl.textContent || '{}') : {};
    const chooseFileLabel = customLineItemsI18n.choose_file || 'Choose file';
    const noFileChosenLabel = customLineItemsI18n.no_file_chosen || 'No file chosen';
    const multipleFilesHint = customLineItemsI18n.multiple_files_hint || '';

    if (!variantsJsonEl) return;

    const variants = JSON.parse(variantsJsonEl.textContent || '[]');
    const form = variantOptionsRoot.closest('form');
    if (!form) return;

    const variantIdInput = form.querySelector('input[name="id"], select[name="id"]');
    const customLineItemsContainer = variantOptionsRoot.querySelector('[data-custom-line-items]');
    const variantPriceElement = document.querySelector('[variant-price]');

    function escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function slugify(value) {
      return String(value ?? '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-_]/g, '');
    }

    function normalizeFields(customFields) {
      if (!customFields) return [];
      if (Array.isArray(customFields)) return customFields;
      return [customFields];
    }

    function renderCustomLineItems(variant) {
      if (!customLineItemsContainer) return;

      const productLevelFields = normalizeFields(productFields);
      const variantLevelFields = variant ? normalizeFields(variant.custom_fields) : [];
      const fieldsToRender = [...productLevelFields, ...variantLevelFields];

      if (fieldsToRender.length === 0) {
        customLineItemsContainer.innerHTML = '';
        return;
      }

      const fieldsHtml = fieldsToRender
        .map((field, index) => {
          const label = field.label || '';
          const propertyName = field.property_name || label || `Feld ${index + 1}`;
          const inputType = (field.input_type || 'text').toLowerCase();
          const fieldId = field.field_id || slugify(propertyName) || `custom-field-${index + 1}`;
          const isRequired = Boolean(field.required_when_visible);

          const requiredAttr = isRequired ? ' required' : '';

          if (inputType === 'textarea') {
            return `
        <p class="line-item-property__field">
          <label for="${escapeHtml(fieldId)}">${escapeHtml(label)}</label>
          <textarea
            id="${escapeHtml(fieldId)}"
            name="properties[${escapeHtml(propertyName)}]"${requiredAttr}
          ></textarea>
        </p>
      `;
          }
          if (inputType === 'file') {
            return `
    <p class="line-item-property__field">
      <label for="${escapeHtml(fieldId)}">${escapeHtml(label)}</label>
      <span class="custom-file-input">
        <span class="custom-file-input__button btn btn-gray">
          <i class="fa-solid fa-paperclip" aria-hidden="true"></i>
          ${escapeHtml(chooseFileLabel)}
        </span>
        <span class="custom-file-input__filename" data-custom-file-filename title="${escapeHtml(noFileChosenLabel)}">${escapeHtml(noFileChosenLabel)}</span>
        <input
          type="file"
          id="${escapeHtml(fieldId)}"
          name="properties[${escapeHtml(propertyName)}]"
          accept=".pdf,.jpg,.jpeg,.png,.zip"
          class="custom-file-input__input"
          data-no-file-chosen-label="${escapeHtml(noFileChosenLabel)}"
          ${requiredAttr}
        >
      </span>
      ${multipleFilesHint ? `<small class="line-item-property__hint">${escapeHtml(multipleFilesHint)}</small>` : ''}
    </p>
  `;
          }

          return `
      <p class="line-item-property__field">
        <label for="${escapeHtml(fieldId)}">${escapeHtml(label)}</label>
        <input
          type="${escapeHtml(inputType)}"
          id="${escapeHtml(fieldId)}"
          name="properties[${escapeHtml(propertyName)}]"${requiredAttr}
        >
      </p>
    `;
        })
        .join('');

      customLineItemsContainer.innerHTML = fieldsHtml;
    }

    function getSelectedOptions() {
      const optionGroups = variantOptionsRoot.querySelectorAll('.variant-options__values');

      return Array.from(optionGroups).map((group) => {
        const checkedInput = group.querySelector('.variant-options__input:checked');
        return checkedInput ? checkedInput.value : null;
      });
    }

    function findMatchedVariant(selectedOptions) {
      return variants.find((variant) => {
        if (!variant.options) return false;
        if (variant.options.length !== selectedOptions.length) return false;

        for (let i = 0; i < variant.options.length; i += 1) {
          if (variant.options[i] !== selectedOptions[i]) return false;
        }

        return true;
      });
    }

    function updateButtonStates() {
      const allInputs = variantOptionsRoot.querySelectorAll('.variant-options__input');

      allInputs.forEach((input) => {
        const button = input.parentElement && input.parentElement.querySelector('.variant-options__button');
        if (!button) return;

        if (input.checked) {
          button.classList.add('variant-options__button--active');
        } else {
          button.classList.remove('variant-options__button--active');
        }
      });
    }

    function updateSelectedVariant() {
      const hasVariantOptions = variantOptionsRoot.querySelectorAll('.variant-options__values').length > 0;

      if (!hasVariantOptions) {
        const firstVariant = variants[0] || null;

        if (firstVariant && variantIdInput) {
          if (variantIdInput instanceof HTMLSelectElement) {
            const optionEl = Array.from(variantIdInput.options).find((opt) => opt.value === firstVariant.id.toString());
            if (optionEl) {
              variantIdInput.value = optionEl.value;
              variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            variantIdInput.value = firstVariant.id;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (firstVariant && variantPriceElement) {
          variantPriceElement.innerText = formatMoney(firstVariant.price);
        }

        renderCustomLineItems(firstVariant);
        return;
      }

      const selectedOptions = getSelectedOptions();

      if (selectedOptions.includes(null)) {
        renderCustomLineItems(null);
        return;
      }

      const matched = findMatchedVariant(selectedOptions);

      if (matched && variantIdInput) {
        if (variantIdInput instanceof HTMLSelectElement) {
          const optionEl = Array.from(variantIdInput.options).find((opt) => opt.value === matched.id.toString());

          if (optionEl) {
            variantIdInput.value = optionEl.value;
            variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          variantIdInput.value = matched.id;
          variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (matched && variantPriceElement) {
        variantPriceElement.innerText = formatMoney(matched.price);
      }

      renderCustomLineItems(matched);
    }

    variantOptionsRoot.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.name.startsWith('options[')) return;

      updateButtonStates();
      updateSelectedVariant();
    });

    if (customLineItemsContainer) {
      customLineItemsContainer.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'file') return;

        const filenameEl = target.parentElement && target.parentElement.querySelector('[data-custom-file-filename]');
        if (!filenameEl) return;

        if (target.files && target.files.length > 0) {
          const names = Array.from(target.files)
            .map((file) => file.name)
            .join(', ');
          filenameEl.textContent = names;
          filenameEl.title = names;
        } else {
          const fallbackLabel = target.dataset.noFileChosenLabel || noFileChosenLabel;
          filenameEl.textContent = fallbackLabel;
          filenameEl.title = fallbackLabel;
        }
      });
    }

    updateButtonStates();
    updateSelectedVariant();
  });

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return 'CHF ' + amount;
  }
  } catch(e) { console.error(e); }
})();

})();
